import React from 'react'
import PropTypes from 'prop-types'

import { config } from 'aws-cognito-redux-saga'

class Auth extends React.Component {
  static propTypes = {
    getUser: PropTypes.func
  };

  componentWillMount() {
    config.config.set({
      region: 'us-east-1',
      IdentityPoolId: '',
      UserPoolId: 'us-east-1_Kr0sRIB7l',
      ClientId: '750brv3g5k39nbg78pdrsp5f1c'
    });

    this.props.getUser()
  }

  render() {
    return null
  }
}

export default Auth
